import React from 'react';
import { brandByKey, brands, criteria } from '../../data/strategy';
import { BrandLegend } from '../deck/BrandLegend';
import { PerceptionChart, type ChartRow } from '../deck/PerceptionChart';
import { SlideFrame } from '../deck/SlideFrame';
function buildRows(view: 'hcp' | 'leo'): ChartRow[] {
  return criteria.map(criterion => ({
    label: criterion.label,
    points: brands.map(brand => ({
      key: brandByKey[brand.key].name,
      value: criterion[view][brand.key],
      color: brand.color
    }))
  }));
}
const hcpRows = buildRows('hcp');
const leoRows = buildRows('leo');
export function WarfareSlide() {
  return <SlideFrame marker="Steps 02 + 03 side by side" data-id="element-177" data-mp="2bldtzuizoy81">
      <div className="shrink-0" data-id="element-178" data-mp="26m104ptpaqvy">
        <h2 className="font-display text-[clamp(26px,4vw,66px)] leading-none tracking-[-0.015em] text-ink" data-id="element-179" data-mp="26n2k5jsp2npt">
          Warfare{' '}
          <span className="text-[clamp(13px,1.7vw,28px)] font-sans font-medium tracking-normal text-ink-soft" data-id="element-180" data-mp="9reip95vagvc">
            prescription criteria
          </span>
        </h2>
      </div>

      <div className="mt-[3vh] flex min-h-0 flex-1 gap-[5%]" data-id="element-181" data-mp="3un3ky8ysm65h">
        {[{
        title: 'HCP perception',
        axis: 'Perceived strength (1 = weaker → 5 = stronger)',
        rows: hcpRows
      }, {
        title: 'LEO fact base',
        axis: 'Defensible strength (1 = weaker → 5 = stronger)',
        rows: leoRows
      }].map(panel => <div key={panel.title} className="flex min-h-0 flex-1 flex-col" data-id="element-182" data-mp="i9drkkrsh6eh">
            <h3 className="shrink-0 pb-[1.8vh] text-center text-[clamp(12px,1.5vw,25px)] font-semibold text-ink" data-id="element-183" data-mp="m839mqnrvc4g">
              {panel.title}
            </h3>
            <div className="min-h-0 flex-1" data-id="element-184" data-mp="dfrqlpuzmqyi">
              <PerceptionChart rows={panel.rows} axisLabel={panel.axis} highlightKey="ENSTILAR®" labelWidth="34%" compact data-id="element-185" data-mp="degmtq1jlj7e" />
            </div>
          </div>)}
      </div>

      <div className="mt-[2.4vh] flex shrink-0 items-center justify-center" data-id="element-186" data-mp="1frj9b3ziv51i">
        <BrandLegend variant="bar" className="max-w-[62%]" data-id="element-187" data-mp="1asy8b2cg4hc0" />
      </div>
    </SlideFrame>;
}